"use client";

import React from "react";
import { MessageCircle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ReadyToWorkInSaudiArabia() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="235184" id="secure-your-investment" className="bg-background text-foreground relative overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute inset-0 z-0 opacity-5 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1645726/img/roof_rain_texture.png)] bg-cover bg-center bg-no-repeat mix-blend-multiply"></div>

      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[80vw] max-w-[800px] h-[80vw] max-h-[800px] bg-primary/5 rounded-full blur-[120px] z-0 pointer-events-none"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div ref={ref} className={`max-w-4xl mx-auto text-center transition-all duration-1000 transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-default font-extrabold mb-6 leading-tight tracking-tighter">
            Is your roof ready for{" "}
            <span className="text-primary block sm:inline mt-2 sm:mt-0">
              the next season?
            </span>
          </h2>
          
          <p className="text-lg md:text-xl text-muted-foreground mb-12 font-default max-w-2xl mx-auto leading-relaxed">
            Protect your property with RM Roofing & Waterproofing. Our expert team delivers high-performance solutions designed to withstand the harshest elements and ensure long-term durability.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
            <Button asChild size="lg" className="w-full sm:w-auto bg-primary hover:bg-primary/90 text-primary-foreground text-base md:text-lg h-14 px-8 rounded-full shadow-xl shadow-primary/20 transition-all hover:scale-105">
              <Link to="/get-a-quote">
                <MessageCircle className="w-5 h-5 ml-2" />
                Request a Free Quote
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}